// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vw_a bhb_b"};